import { CartFilters } from "@/types/cart";

export const CART_KEY = "CART";

export const CART_CACHE_KEY = {
  LIST: (filters: CartFilters) => [CART_KEY, "LIST", filters] as const,
};
